<template>
    <div class="dhmap-wrapper">
        <!-- 不展示周边 -->
      <locator-point :param="param" mode='h5' v-if="!type"></locator-point>
      <!-- 展示周边 -->
      <locator-report :param="param" :mapData="mapData" mode='h5' v-else></locator-report>
    </div>
  </template>
  
  <script>
  import locatorPoint from "./LocatorPoint";
  import locatorReport from "./locatorReport";
  import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
  export default {
    name: "locator",
    components: {locatorPoint,locatorReport},
    props: {},
    data() {
      return {
          clientType: "",
          param:{},
          type:false,//是否展示周边信息
          mapData:{
            zrqlx:'geo_xian',//责任区geo_grid_shi,还是政区geo_shi
            zrqobjid:'16ca0d0d-e8d4-414e-bbd1-44af3156a83c',//objid
            toolbar: "none",
            zqCode:''
          },
      }
    },
    mounted(){
      let _this=this;
      this.clientType = getDeviceType();
      if(this.$route.query.type && this.$route.query.objid){
        this.param = {type:this.$route.query.type,objid:this.$route.query.objid}
        
      }else{
        this.$toast('查询参数不正确')
      }
      
      if(this.$route.query.taskRegionType){
        let taskRegionType=this.$route.query.taskRegionType;//任务接收政区类型:zq-政区 zrq-责任区
        let taskRegionLevel=this.$route.query.taskRegionLevel;//任务接收所在的责任区级别
        let taskGridObjid=this.$route.query.taskGridObjid;//任务责任区的objid
        let taskRegionCode=this.$route.query.taskRegionCode;//任务接收所在的政区
        if (_this.clientType == "android") {
          this.type=this.$route.query.taskRegionShow =='false'?false:true;
        } else {
          this.type=this.$route.query.taskRegionShow>0?true:false;//接收人责任区是否展示:true-责任区 false 定位的点
        }
        console.log(this.$route.query.taskRegionShow =='false',this.type)
        this.mapData={
            zrqlx:this.getZq(taskRegionType,taskRegionLevel),
            zrqobjid:taskGridObjid,
            toolbar:'block',
            zqCode:taskRegionCode
        }
      }
    },
    methods:{
        getZq(taskRegionType,taskRegionLevel){
            let gridtypes = [
                "geo_grid_sheng",
                "geo_grid_shi",
                "geo_grid_xian",
                "geo_grid_xiang",
                "geo_grid_cun",
                ],
                zqTypes = [
                "geo_sheng",
                "geo_shi",
                "geo_xian",
                "geo_xiang",
                "geo_cun",
                ]
                  if(taskRegionType=='zq'){
                    return zqTypes[Number(taskRegionLevel)-1]
                  }else{
                    return gridtypes[Number(taskRegionLevel)-1]
                  }
        }
    },
    computed:{
        
    }
  }
  </script>
  
  <style scoped>
  .dhmap-wrapper{
    width:100%;
    height: 100%;
  }
  </style>